import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Dialog         from '@material-ui/core/Dialog'
import DialogActions  from '@material-ui/core/DialogActions'
import DialogContent  from '@material-ui/core/DialogContent'
import DialogTitle    from '@material-ui/core/DialogTitle'
import Grid           from '@material-ui/core/Grid'
import { withFormik } from 'formik'

import { ActionButton, EnhancedTextField, LoadingOverlay }            from '../atoms'
import { genValueMapper, mapFormikToMuiProps, proxyFormikSubmission } from './form-utils'
import { emptySessionMeta, sessionMetaSchema }                        from './schemas'
import { FormikComponentProps, SessionCompletionFields }              from './types'

interface CompleteSessionFormDialogProps {
  isOpen: boolean
}

type Props =
  CompleteSessionFormDialogProps
  & FormikComponentProps<SessionCompletionFields>

const SessionCompleteFormDialog = withFormik<Props, SessionCompletionFields>({
  mapPropsToValues: genValueMapper(emptySessionMeta),
  validationSchema: sessionMetaSchema,
  handleSubmit:     proxyFormikSubmission,
})(
  props => {
    const phrasing = {
      confirmCompletionPrompt:
        (
          <FormattedMessage
            id={'generic.confirmAppointmentCompletionPrompt'}
            defaultMessage={'About your last session'}
          />
        )
    }

    const propsMapper = mapFormikToMuiProps(props)

    const {
      close,
      isOpen,
      fetching,
      handleSubmit
    } = props

    return (
      <Dialog fullWidth onClose={close} open={isOpen}>
        <LoadingOverlay show={fetching}>
          <form onSubmit={handleSubmit}>
            <DialogTitle>
              {phrasing.confirmCompletionPrompt}
            </DialogTitle>

            <DialogContent>
              <Grid
                container
                direction={'column'}
                spacing={16}
              >
                <Grid item>
                  <EnhancedTextField
                    fullWidth
                    multiline
                    rows={2}
                    {...propsMapper('goals')}
                  />
                </Grid>
                <Grid item>
                  <EnhancedTextField
                    fullWidth
                    multiline
                    rows={2}
                    {...propsMapper('achievements')}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <ActionButton
                type={'submit'}
                color={'primary'}
                variant={'raised'}
                actionType={'submit'}
              />
            </DialogActions>
          </form>
        </LoadingOverlay>
      </Dialog>
    )
  },
)

export default SessionCompleteFormDialog



// WEBPACK FOOTER //
// ./src/components/forms/SessionCompleteFormDialog.tsx